<template>
  <div>
    <div ref="areaChart" :style="{ width: '100%', height: '400px' }"></div>
  </div>
</template>
 
<script>
import * as echarts from 'echarts';
export default {
  data() {
    return {};
  },
  mounted() {
    this.change();
    //图表自适应大小
    window.addEventListener('resize', this.chart.resize);
  },
  methods: {
    change() {
      const eChart = this.$refs.areaChart;
      this.chart = echarts.init(eChart);
      const option = {
        color: 'rgba(0, 174, 147, 1)',
        tooltip: {
          trigger: 'axis',
          borderWidth: '0', //边框宽度设置1
          borderColor: 'none', //设置边框颜色
          padding:20, 
          textStyle: {
            color: 'rgba(209, 212, 220, 1)', //设置文字颜色
          },
          extraCssText:
            'background:rgba(61, 63, 71, 1);',
        },
        grid: {
          left: '1%',
          right: '3%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['2021-12-11', '2022-01-11', '2022-02-11', '2022-03-11', '2022-04-11', '2022-05-11', '2022-06-11'],
          axisLabel: {
            textStyle: {
              color: 'rgba(209, 212, 220, 1)',
            },
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: ['rgba(159, 159, 159, 0.1)'],
            },
          },
          axisLabel: {
            formatter: '{value} 万',
            textStyle: {
              color: 'rgba(209, 212, 220, 1)',
            },
          },
        },
        series: [
          {
            name: "金额",
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            lineStyle: {
              color: 'rgba(0, 174, 147, 1)',
            },
            itemStyle: {
              normal: {
                color: 'rgba(0, 174, 147, 1)',
              },
            },

            areaStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0.1,
                      color: 'rgba(0, 174, 147, 0.2000)', // 0% 处的颜色
                    },
                    {
                      offset: 0.9,
                      color: 'rgba(0, 174, 147, 0)', // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      // 设置配置项
      this.chart.setOption(option);
    },
  },
};
</script>
 
<style lang="scss" >
</style>


// WEBPACK FOOTER //
// src/echarts/AreaChart.vue